import { PreloadedQuery } from "react-relay";

import FeatureGates from "@atlaskit/feature-gate-js-client";

import { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { IntercomProvider } from "@/libraries/intercom/src";
import { JiraServiceManagementPricingPageV2Template } from "@/templates/software/jira/service-management/pricing/jira-service-management-pricing-page-v2/src";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content.ts";
import { UserLocale } from "@/utils/useGeoCurrency";

import { AppPricingData } from "../../../../../contentful";

export type JiraServiceManagementPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const JiraServiceManagementPricingPage = ({
    pricing,
    countryCode,
    pricingContent,
    queryRef
}: JiraServiceManagementPricingPageProps) => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-jsm"
    );

    return (
        <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
            <PricingContentContextProviderRelay
                productId="jira-service-management"
                pricingContent={pricingContent}
                queryRef={queryRef}
            >
                <div data-testid="jsm-pricing-page">
                    <JiraServiceManagementPricingPageV2Template
                        pricing={pricing}
                        countryCode={countryCode}
                    />
                </div>
            </PricingContentContextProviderRelay>
        </IntercomProvider>
    );
};
